import { Link, createFileRoute } from "@tanstack/react-router";

import ApiKeysSettings from "@/components/ApiKeysSettings";
import { AppHeader } from "@/components/app-header";
import { RequireAuth } from "@/components/route-guards";
import { useAuth } from "@/lib/auth";
import { signOut } from "@/lib/platform-fetch";

/**
 * `/settings/api-keys` -- the caller's personal API keys and what each spent this month
 * (docs/OPENCODE.md). Same shell as `/settings/integrations`.
 */
export const Route = createFileRoute("/settings/api-keys")({
  component: ApiKeysRoute,
});

function ApiKeysRoute() {
  return (
    <RequireAuth>
      <ApiKeysPage />
    </RequireAuth>
  );
}

function ApiKeysPage() {
  const { user, hasAdminAccess, skillsEnabled } = useAuth();

  return (
    <main className="flex min-h-dvh flex-col">
      <AppHeader
        left={<Link to="/">&larr; Back to chat</Link>}
        userLabel={user?.email ?? user?.name ?? "unknown"}
        hasAdminAccess={hasAdminAccess}
        skillsEnabled={skillsEnabled}
        signOutAction={signOut}
      />
      <ApiKeysSettings />
    </main>
  );
}
